import {useState} from "react";
import {Link, useNavigate} from "react-router-dom";
import {login} from "../../api/client";

function Login({onAuthSuccess}) {
    const navigate = useNavigate();
    const [isLeaving, setIsLeaving] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [error, setError] = useState("");

    async function handleSubmit(event) {
        event.preventDefault();
        setError("");
        setIsSubmitting(true);

        const formData = new FormData(event.currentTarget);
        const remember = formData.get("remember") === "on";

        try {
            const authResponse = await login({
                phone: formData.get("phone"),
                password: formData.get("password"),
                remember,
            });

            onAuthSuccess(authResponse, remember);
            setIsLeaving(true);
            window.scrollTo({top: 0, behavior: "smooth"});

            setTimeout(() => {
                navigate("/");
                requestAnimationFrame(() => {
                    window.scrollTo({top: 0, behavior: "smooth"});
                });
            }, 240);
        } catch (requestError) {
            setError(requestError.message);
        } finally {
            setIsSubmitting(false);
        }
    }

    return (
        <main className={isLeaving ? "auth-page auth-page-exiting" : "auth-page"}>
            <form className="auth-card" onSubmit={handleSubmit}>
                <Link className="auth-back" to="/">
                    <span aria-hidden="true">&lt;</span>
                    На главную
                </Link>

                <div className="auth-card-header">
                    <h1>Вход</h1>
                    <p>Введите данные для доступа в личный кабинет.</p>
                </div>

                {error && <p className="auth-error">{error}</p>}

                <label>
                    Номер телефона
                    <input
                        type="tel"
                        name="phone"
                        autoComplete="tel"
                        inputMode="tel"
                        placeholder="+79500000000"
                        pattern="^\+?[0-9\s()\-]{10,20}$"
                        title="Введите корректный номер телефона"
                        required
                    />
                </label>

                <label>
                    Пароль
                    <input
                        type="password"
                        name="password"
                        autoComplete="current-password"
                        placeholder="Введите пароль"
                        minLength="8"
                        required
                    />
                </label>

                <label className="auth-checkbox">
                    <input type="checkbox" name="remember"/>
                    <span>
                        Запомнить меня
                    </span>
                </label>

                <button className="auth-submit" type="submit" disabled={isSubmitting}>
                    {isSubmitting ? "Входим..." : "Войти"}
                </button>

                <span className="auth-switch">
                    Нет аккаунта? <Link to="/register">Зарегистрироваться</Link>
                </span>
            </form>
        </main>
    );
}

export default Login;
